import React from 'react';
import { useTenantConfig } from '../../../hooks';
import { getTrackingData } from '@teko/tracking';
import { styled } from '@teko/ds-mobile';
import dynamic from 'next/dynamic';
import { CartHeader } from './CartHeader';

const FacebookMessengerFilled = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.FacebookMessengerFilled),
);
const ZaloFilled = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.ZaloFilled),
);

interface HeaderIconProps {
  isVisible?: boolean;
  transitionDelay?: string;
  isDisplayContact?: boolean;
  onlyShowLocationIcon?: boolean;
  isShowCartIcon?: boolean;
}

const Wrapper = styled.div<Omit<HeaderIconProps, 'setShowRegionPopup'>>(
  ({ isVisible, transitionDelay, theme }) => `
    max-width: ${isVisible ? '180px' : '0px'};
    display: ${isVisible ? 'flex' : 'none'};
    transition: max-width 0.2s ${isVisible ? 'ease-in' : 'ease-out'};
    transition-delay: ${isVisible ? transitionDelay : '0s'};
    overflow: hidden;
    align-items: center;
    column-gap: ${theme.spacing.s12};
    flex: 0 0 auto;
  `,
);

const Anchor = styled.a``;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderIcon: React.FC<HeaderIconProps> = ({
  isVisible = true,
  transitionDelay = '0s',
  isDisplayContact = true,
  isShowCartIcon = false,
}: HeaderIconProps) => {
  const { contactLink, isDisplayMessenger, zaloContactLink, displayNewLayout } =
    useTenantConfig();

  return (
    <>
      <Wrapper isVisible={isVisible} transitionDelay={transitionDelay}>
        {isDisplayContact && contactLink && isDisplayMessenger && (
          <Anchor href={contactLink} target="_blank" rel="noreferrer">
            <IconWrapper
              {...getTrackingData({
                isTrackContent: true,
                regionName: 'quickAction',
                contentName: 'fbMessengerIcon',
              })}
            >
              <FacebookMessengerFilled size={30} color="#fff" />
            </IconWrapper>
          </Anchor>
        )}
        {zaloContactLink && (
          <Anchor href={zaloContactLink} target="_blank" rel="noreferrer">
            <IconWrapper
              {...getTrackingData({
                isTrackContent: true,
                regionName: 'quickAction',
                contentName: 'zaloMessengerIcon',
              })}
            >
              <ZaloFilled size={24} color="#fff" />
            </IconWrapper>
          </Anchor>
        )}
        {isShowCartIcon && (
          <CartIcon
            iconSize={24}
            badgeWidth={12}
            badgeTop={0}
            iconColor="#fff"
            type={displayNewLayout ? 'outlined' : 'filled'}
          />
        )}
      </Wrapper>
    </>
  );
};

const CartIcon = styled(CartHeader)`
  padding: 0;
  .cart-badge {
    background-color: white;
    color: black;
    line-height: 12px;
    height: 12px;
  }
`;
